module.exports = __webpack_public_path__ + "media/newstyle/images/icon-close-quote-65aa7cb123605cf5134003b3fb2369a0.svg";